import { useInvoiceFormContext } from "contexts/invoicePage/InvoiceFormContext";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import { getActionInvoiceDisplay } from "utils/HelperInvoiceFunction";
export default function useInvoiceStatusHandler() {
    var values = useFormikContext().values;
    var formdisabled = useInvoiceFormContext().formdisabled;
    var docStatusState = useMemo(function() {
        return getActionInvoiceDisplay({
            formdisabled: formdisabled || false,
            dimMstNewStatus: values === null || values === void 0 ? void 0 : values.dimMstInvoiceStatus,
            values: values || {}
        });
    }, [
        formdisabled,
        values
    ]);
    return docStatusState;
}
